import { useDemoRequest } from "@/components/feature/DemoRequest";

export default function BespokeSection() {
  const { open } = useDemoRequest();
  return (
    <section className="relative py-16 md:py-24 bg-graphite-900">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
            <div>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
                Bespoke Development
              </h2>
              <p className="text-emerald-accent font-medium mb-6">
                Every business operates differently and sometimes, off-the-shelf solutions are not enough.
              </p>
              <div className="space-y-4 text-base text-silver-300 leading-relaxed mb-8">
                <p>
                  At StackMap Systems, we design and build custom applications tailored to your specific workflows, processes, and operational needs. Whether you are managing complex logistics, distributed teams, or unique business models, our bespoke development approach ensures that your systems are built around how your business actually runs, not the other way around.
                </p>
                <p>
                  We work closely with your team to understand your operations, identify gaps, and develop solutions that deliver structure, visibility, and control across your business.
                </p>
              </div>
              <div className="mb-6">
                <p className="text-sm font-semibold text-white uppercase tracking-wider mb-3">
                  From internal tools to full-scale platforms, our bespoke solutions are:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-silver-300">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-emerald-accent" />
                    </span>
                    Fully aligned with your business processes
                  </li>
                  <li className="flex items-start gap-2 text-sm text-silver-300">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-emerald-accent" />
                    </span>
                    Scalable as your operations grow
                  </li>
                  <li className="flex items-start gap-2 text-sm text-silver-300">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-emerald-accent" />
                    </span>
                    Integrated with your existing systems where required
                  </li>
                  <li className="flex items-start gap-2 text-sm text-silver-300">
                    <span className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-emerald-accent" />
                    </span>
                    Designed for ease of use and real-world execution
                  </li>
                </ul>
              </div>
              <p className="text-base text-silver-300 leading-relaxed mb-8">
                If your business needs something beyond standard software, we build systems that fit precisely.
              </p>
              <button onClick={open} className="btn-primary inline-block text-center cursor-pointer">Discuss Your Needs</button>
            </div>
            <div className="space-y-4 lg:sticky lg:top-24">
              <div className="glass-card p-2 md:p-3 rounded-xl overflow-hidden">
                <img
                  alt="Bespoke task management dashboard with project cards and workflow boards"
                  className="w-full rounded-lg object-contain"
                  src="https://readdy.ai/api/search-image?query=A%20modern%20dark-themed%20project%20management%20dashboard%20interface%20showing%20a%20kanban-style%20board%20with%20multiple%20project%20cards%20arranged%20in%20columns%2C%20each%20card%20displaying%20task%20titles%2C%20status%20labels%2C%20and%20progress%20indicators%2C%20dark%20charcoal%20background%20with%20subtle%20green%20accent%20highlights%20on%20active%20cards%2C%20clean%20minimal%20UI%20design%20with%20rounded%20corners%2C%20no%20readable%20text%20or%20logos%2C%20professional%20SaaS%20software%20screenshot%20aesthetic%2C%20sharp%20focus%2C%20high%20quality&width=800&height=500&seq=bespoke-img-1&orientation=landscape"
                />
              </div>
              <div className="glass-card p-2 md:p-3 rounded-xl overflow-hidden">
                <img
                  alt="Bespoke analytics dashboard with performance charts and metrics"
                  className="w-full rounded-lg object-contain"
                  src="https://readdy.ai/api/search-image?query=A%20modern%20dark-themed%20analytics%20dashboard%20interface%20showing%20line%20graphs%20and%20area%20charts%20tracking%20business%20performance%20metrics%20over%20time%2C%20multiple%20data%20visualization%20panels%20with%20green%20and%20teal%20accent%20colors%20on%20a%20dark%20charcoal%20background%2C%20clean%20minimal%20UI%20design%20with%20rounded%20corners%2C%20no%20readable%20text%20or%20logos%2C%20professional%20SaaS%20software%20screenshot%20aesthetic%2C%20sharp%20focus%2C%20high%20quality&width=800&height=500&seq=bespoke-img-2&orientation=landscape"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}